import React from 'react';
import { Button } from 'antd';
import { OpenInNew } from '@mui/icons-material';
import { useAppSelector } from '@/store/hooks/useAppSelector';
import { getLoggedInUser } from '@/store/account/selector';

const LearnMore: React.FC<{ tutorialId: string | undefined; debrand?: boolean }> = ({
	tutorialId,
	debrand = false,
}) => {
	const loggedInUser = useAppSelector(getLoggedInUser);

	const handleTutorialClick = () => {
		if (!tutorialId) {
			return;
		}
		// open the corresponding OpenInNew in a new tab
		window.open(tutorialId, '_blank');
	};

	return (
		!loggedInUser?.resellerClient &&
		!debrand && (
			<Button
				type="default"
				onClick={handleTutorialClick}
				icon={<OpenInNew />}
				className="flex items-center border-blue-100 bg-blue-50 hover:bg-blue-100 hover:border-blue-200 text-blue-700"
			>
				Learn More
			</Button>
		)
	);
};

export default LearnMore;
